import React from 'react'
import Flickity from 'react-flickity-component'
import SearchIcon from '../../Components/Icons/Search/Search'
import PlayIcon from '../../Components/Icons/Play/Play'
import { Dark, Dark2, White, } from '../../Constants/ColorChart'
import LikeIcon from "../LikeIcon/LikeIcon";
import 'flickity/dist/flickity.min.css';
import FeatherIconWrapper from "../Icons/FeatherIconWrapper";
import { PlaylistsViewItem, PlaylistsViewItemType, Title, PlaylistsViewItemData } from './StyledPlaylistsViews'

const flickityOptions = {
    initialIndex: 0,
    contain: true,
    pageDots: false,
    cellAlign: 'left',
    groupCells: true
}

export const PlaylistsCarousel = ( props ) => {
    const { type, items,  handleClick } = props;
    const isItPlaylist = type === "playlist";
    const background = isItPlaylist ? Dark : White;
    const color = isItPlaylist ? White : Dark;
    const itemType = isItPlaylist ? "Playlist" : "Search"

    return (
        <Flickity
            className={ 'carousel' }
            elementType={ 'div' }
            options={ flickityOptions }
            reloadOnUpdate
            static
        >
            { items.map ( ( item, index ) => {
                return (
                    <PlaylistsViewItem
                        key={ item.uuid + "-" + index }
                        className={ "PlaylistsViewItem" }
                        background={ background }
                        onClick={ () => {
                            const data = {
                                type,
                                title: item.name,
                                id: isItPlaylist ? item.id : undefined
                            }
                            handleClick ( data )
                        } }
                        seeAllPlaylist={false}
                    >
                        <PlaylistsViewItemType color={ color }>{ itemType }</PlaylistsViewItemType>
                        <Title color={ color }>{ item.name }</Title>
                        {
                            isItPlaylist &&
                            <LikeIcon
                                color={ Dark2 }
                                fillColor={ Dark2 }
                                width={ "30px" }
                                activeStyle={ `position: absolute; height:30px; bottom: 35px; fill: ${ Dark2 }; stroke: ${ Dark2 }` }
                                unactiveStyle={ `position: absolute; height:30px; bottom: 35px; fill: none; stroke: ${ Dark2 }` }
                                active={ item.isLikedByCurrentUser }
                                itemId={ item.id }
                                likeId={ item.id }
                            />
                        }

                        {
                            isItPlaylist &&
                            <PlaylistsViewItemData>{ item.itemsCount + " files" }</PlaylistsViewItemData>
                        }
                        <FeatherIconWrapper
                            color={ Dark2 }
                            iconStyle="position: absolute; bottom: 14px; width: 60px!important; height: 60px!important; right: 10px;"
                            Icon={ isItPlaylist ? PlayIcon : SearchIcon }
                        />
                    </PlaylistsViewItem>
                )
            } ) }
        </Flickity>
    )
}
